/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Provides general components for this container
 */
import Item from './item';
import Info from './info';

export { Item, Info };



// WEBPACK FOOTER //
// ./containers/despachos/components/index.js